import { Typography } from '@occc-app/design-system';

import { errorMessage } from '../retailer-connect.copies';

export const RetailerNetworkErrorMessage = ({ message }: { message?: string }) => {
  return (
    <Typography color='error' align='center' my={16} data-testid='something-went-wrong-msg'>
      {message || errorMessage}
    </Typography>
  );
};
